import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";

export default class ControllerFWVersionCard extends BaseComponent{

    constructor(props) {
        super(props);
        let {assembly} = this.props
        if(isEmpty(assembly)){
            assembly = {}
        }
        this.setState({assembly})
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {assembly} = nextProps
            if(isEmpty(assembly)){
                assembly = {}
            }
            this.setState({assembly}, () => {
                // alert(assembly.reference)
                // console.log("@@@@@@@@@@@@@@@@@@@@@@ = "+JSON.stringify(assembly))
            })
        }
    }

    render() {
        let {assembly} = this.state
        if(isEmpty(assembly)){
            assembly = {}
        }
        let {headerClassName} = this.props
        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header className={headerClassName}>
                    {label.FWVersion} {label.And} {label.Controller}
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col xs={12} lg={6} className="text-left">
                            <TextInput
                                label={label.FWVersion}
                                icon={faCode}
                                readOnly={true}
                                value={assembly.fwVersion}
                            />
                        </Col>
                        <Col xs={12} lg={6} className="text-left">
                            <TextInput
                                label={label.Controller}
                                icon={faCode}
                                readOnly={true}
                                value={assembly.controller}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

ControllerFWVersionCard.propTypes = {
    assembly : PropTypes.any,
    headerClassName: PropTypes.string
}